import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {
  userRoundCheckBlue,
  userRoundCheckGreen,
  userRoundCheckRed,
} from '../../../assets/images/images';
import {
  customStyles,
  // SettingsToggle,
  DropdownIndicator,
  Radios,
} from '../../../components';
import {useFraudCheck, usePersistFraudData} from '../../../hooks/useFraudCheck';
import {Card, Wrapper} from '../FraudCheckScreens';
import {userDataMatchRules} from '../../../helpers/constants/widgets';

export const DetectWithUserData = () => {
  const [nameMatchRule, setNameMatchRule] = useState('');
  const {setSelectedStatus, selectedStatus, setConfig, config, STATUSES} =
    useFraudCheck({
      // fields: ['first_name'],
      action: 'pending',
      two_names_rule: false,
    });
  const statusData = usePersistFraudData({
    config,
    selectedStatus,
    actionKey: 'action',
    COLLECTION: STATUSES,
  });

  useEffect(() => {
    if (config?.two_names_rule) {
      setNameMatchRule('Enable');
    } else {
      setNameMatchRule('');
    }
  }, [config?.two_names_rule]);

  // const handleFieldCheck = useCallback(
  //   value => {
  //     !enabled[value]
  //       ? setConfig({...config, fields: [...(config.fields || []), value]})
  //       : setConfig({
  //           ...config,
  //           fields: config?.fields.filter(field => field !== value),
  //         });
  //   },
  //   [enabled, setConfig, config],
  // );

  // useEffect(() => {
  //   if (!config?.fields?.length) {
  //     setEnabled({...enabled});
  //   } else {
  //     const userFields = config?.fields?.reduce(
  //       (acc, curr) => ({
  //         ...acc,
  //         [curr]: true,
  //       }),
  //       {},
  //     );
  //     setEnabled({...userFields});
  //   }
  // }, [Object.keys(enabled).length, setEnabled, config.fields.length]);

  // const fieldsToMatch = [
  //   {label: 'First name', value: 'first_name'},
  //   {label: 'Last name', value: 'last_name'},
  //   {label: 'Middle name', value: 'middle_name'},
  //   {label: 'Date of birth', value: 'dob'},
  // ];
  return (
    <Wrapper>
      <Card
        extension={
          <div className="flex flex-col">
            <p className="text-grey font-medium">Detect with user data</p>
            <p className="text-body text-sm gap-1">
              Set rules to detect mismatches by comparing user data with
              government records.
            </p>
          </div>
        }
        src={userRoundCheckBlue}
      />
      <Card
        extension={
          <div className="flex flex-col">
            <p className="text-grey font-medium">User data match rule</p>
            <p className="text-body text-sm gap-1">
              This ensures that the user’s names and the date of birth match the
              government records.
            </p>
          </div>
        }
        src={userRoundCheckGreen}
      >
        <Radios
          data={userDataMatchRules}
          flexDirection="flex-row gap-4"
          radioClassName="bg-white80 w-full p-3 py-3 rounded"
          outerRadioClassName="w-full"
          padding="px-0"
          className="ml-6  w-full"
          onCheck={e => {
            const {value} = e.target;
            setNameMatchRule(value);
            setConfig({...config, two_names_rule: Boolean(value)});
          }}
          radioValue={nameMatchRule}
        />

        {/*<div className="flex items-center gap-2 p-4 rounded bg-white80 w-full">*/}
        {/*  <SettingsToggle*/}
        {/*    isChecked={config?.two_names_rule}*/}
        {/*    onCheck={value => {*/}
        {/*      setConfig({...config, two_names_rule: value});*/}
        {/*    }}*/}
        {/*  />*/}
        {/*  <p className="text-grey text-sm">*/}
        {/*    {config?.two_names_rule ? 'Disable' : 'Enable'} match rule{' '}*/}
        {/*  </p>*/}
        {/*</div>*/}
      </Card>

      {/*<Card*/}
      {/*  extension={*/}
      {/*    <div className="flex flex-col">*/}
      {/*      <p className="text-grey font-medium">Select fields to match</p>*/}
      {/*      <p className="text-body text-sm gap-1">*/}
      {/*        Choose which user data should match*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*  }*/}
      {/*  src={userRoundCheckGreen2}*/}
      {/*>*/}
      {/*  <div className="flex flex-col gap-2 w-full">*/}
      {/*    {fieldsToMatch.map(field => (*/}
      {/*      <div*/}
      {/*        key={field.value}*/}
      {/*        className="flex items-center gap-2 p-4 rounded bg-white80"*/}
      {/*      >*/}
      {/*        <SettingsToggle*/}
      {/*          isChecked={*/}
      {/*            config?.fields?.includes(field.value) || enabled[field.value]*/}
      {/*          }*/}
      {/*          onCheck={data => {*/}
      {/*            setEnabled({...enabled, [field.value]: data});*/}
      {/*            handleFieldCheck(field.value);*/}
      {/*          }}*/}
      {/*        />*/}
      {/*        <p className="text-grey text-sm">{field.label}</p>*/}
      {/*      </div>*/}
      {/*    ))}*/}
      {/*  </div>*/}
      {/*</Card>*/}
      <Card
        extension={
          <p className="text-grey font-medium">If fields do not match</p>
        }
        src={userRoundCheckRed}
      >
        <div className="text-start w-full">
          <label htmlFor="status" className="mb-2 relative">
            Set Status to
          </label>
          {statusData !== undefined && (
            <Select
              defaultValue={statusData}
              value={statusData || STATUSES[0]}
              onChange={data => {
                setConfig({...config, action: data?.value});
                setSelectedStatus(data);
              }}
              options={STATUSES}
              className="basic-multi-select white-select"
              classNamePrefix="react-select"
              components={{DropdownIndicator}}
              styles={customStyles}
              menuPlacement="auto"
              isSearchable={false}
            />
          )}
        </div>
      </Card>
    </Wrapper>
  );
};
